import $ from 'jquery';

import '../lib/fade-in-on-scroll.js';
